import { Box } from '@mui/material';
import SectionTitle from 'components/drawers/transaction-drawers/section-title/section-title.component';
import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckboxField from '../fields/checkbox-field/checkbox-field.component';
import CurrencyField from '../fields/currency-field/currency-field.component';
import AmountTypeSelect from './amount-type-select/amount-type-select.component';

const RefundForm = ({ transaction, refundableAmountValue }) => {
  const { t } = useTranslation();
  const isPartialRefund = useWatch({ name: 'isPartialRefund' });

  return (
    <Box>
      <SectionTitle title={t('forms.fields.refundForm.title')} />
      <AmountTypeSelect
        name="isPartialRefund"
        transaction={transaction}
        refundableAmountValue={refundableAmountValue}
      />
      <CurrencyField
        name="refundAmount"
        label={t('forms.fields.refundForm.amount.label')}
        data-testid="RefundForm.RefundAmount"
        disabled={!isPartialRefund}
      />
      <IncTextField
        name="refundReason"
        label={t('forms.fields.refundForm.reason.label')}
        data-testid="RefundForm.RefundReason"
        multiline
      />
      <IncTextField
        name="requestedBy"
        label={t('forms.fields.refundForm.employeeName.label')}
        data-testid="RefundForm.EmployeeName"
      />
      <CheckboxField
        name="emailReceipt"
        label={t('forms.fields.refundForm.emailReceipt.label')}
        data-testid="RefundForm.CheckboxField"
        helperText={t('forms.fields.refundForm.emailReceipt.helperText')}
        helperTextSeverity="warning"
      />
    </Box>
  );
};

export default RefundForm;
